export enum actionTypes {
  TRABAJOS_FETCH = 'TRABAJOS_FETCH',
  TRABAJOS_SUCCESS = 'TRABAJOS_SUCCESS',
  TRABAJOS_ERROR = 'TRABAJOS_ERROR',
  TRABAJOS_RESET = 'TRABAJOS_RESET',
}

export enum TrabajosStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Trabajo {
  id: number
  nombre: string
}

export interface TrabajosState {
  status: TrabajosStatus
  trabajos: Array<Trabajo>
}

export interface TrabajosFetch {
  type: typeof actionTypes.TRABAJOS_FETCH
}

export interface TrabajosSuccess {
  type: typeof actionTypes.TRABAJOS_SUCCESS
  payload: { trabajos }
}

export interface TrabajosError {
  type: typeof actionTypes.TRABAJOS_ERROR
  payload: null
}

export interface TrabajosReset {
  type: typeof actionTypes.TRABAJOS_RESET
  payload: null
}

export type TrabajosActions = TrabajosFetch | TrabajosSuccess | TrabajosError | TrabajosReset

export const initialState: TrabajosState = {
  status: TrabajosStatus.Idle,
  trabajos: [],
}
